//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BaseLoading from '@/components/BaseLoading';
import PaginationBasic from '@/components/PaginationBasic.vue';
import DataProfilingService from '@/apps/data-platform/services/data_quality/data_profiling_service';
import utils from '@/js/utils';
export default {
  name: 'ModalProfilingRules',
  props: {
    tableReference: {
      type: Object,
      required: true,
      default: function _default() {}
    }
  },
  components: {
    BaseLoading: BaseLoading,
    PaginationBasic: PaginationBasic
  },
  data: function data() {
    return {
      sortBy: 'creationTime',
      sortDesc: true,
      isBusy: false,
      perPage: 5,
      currentPage: 1,
      pagination: {
        current: 1,
        limit: 5,
        total: 0,
        offset: 0
      },
      fields: [{
        key: 'profilingRule.name',
        label: 'Rule Name',
        sortable: true
      }, {
        key: 'profilingRule.description',
        label: 'Description',
        sortable: true
      }, {
        key: 'creationTime',
        label: 'Creation Time',
        sortable: true
      }, {
        key: 'finishTime',
        label: 'Finish Time',
        sortable: true
      }, {
        key: 'actions',
        label: '  ',
        class: 'text-center'
      }],
      items: [],
      item: Object
    };
  },
  created: function created() {
    this.getProfilingRules();
  },
  methods: {
    getProfilingRules: function getProfilingRules() {
      var _this = this;
      this.isBusy = true;
      this.params = {
        tableReference: this.tableReference,
        pagination: utils.cloneJSON(this.pagination)
      };
      this.params.pagination.limit++;
      DataProfilingService.getProfilingHistory(this.params).then(function (response) {
        _this.items = response.data;
        if (_this.items.length === _this.pagination.limit + 1) {
          _this.items.splice(_this.items.length - 1);
          _this.pagination.total = _this.pagination.limit;
        } else {
          _this.pagination.total = _this.pagination.limit - 1;
        }
        _this.isBusy = !_this.isBusy;
      });
    },
    changePage: function changePage(currentPage) {
      this.pagination.current = currentPage;
      this.pagination.offset = (this.pagination.current - 1) * this.pagination.limit;
      this.getProfilingRules();
    }
  },
  computed: {
    rows: function rows() {
      return this.items.length;
    }
  }
};